import Palette from '~/models/palette/Palette'
import { getGradient } from '@/models/general/GradientModel'

export class FollowingMediaStyleModel {
  constructor() {
    this.background = ''
    this.backgroundColor = ''
    this.padding = null
    this.margin = null
    this.gap = null
  }

  fromData({
    backgroundColor = '',
    padding = null,
    margin = null,
    gradient = null,
    spacing = 0,
  }) {

    const palette = new Palette()
    palette.checkColor(backgroundColor)
    this.backgroundColor = palette.color

    if (spacing) this.gap = `${spacing}px`

    if (padding)
      this.padding = `${padding.top}px ${padding.right}px ${padding.bottom}px ${padding.left}px`
    if (margin)
      this.margin = `${margin.top}px ${margin.right}px ${margin.bottom}px ${margin.left}px`

    if (gradient) this.background = getGradient(gradient)
  }
}
export function formatFollowingMediaStyle(data) {
  const media = new FollowingMediaStyleModel()
  media.fromData(data)

  return media
}
